webpackJsonp([47877783677342],{

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = MonzoRound;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MonzoRound() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "71", height: "71", viewBox: "0 0 71 71" },
	    _react2.default.createElement("circle", { fill: "#fff", cx: "35.5", cy: "35.5", r: "35.5" }),
	    _react2.default.createElement("path", {
	      d: "M56.257 44.808c0 .498-.199.976-.554 1.328l-8.466 8.41c-.476.473-1.291.138-1.291-.531v-18.845l10.193-10.069h.118v19.707",
	      fill: "#E83860",
	      fillRule: "nonzero"
	    }),
	    _react2.default.createElement("path", {
	      d: "M49.501 18.39c-.295-.293-.774-.293-1.069 0l-12.589 12.505h-.175v14.114l.175.371 10.104-10.037 10.311-10.243-6.756-6.711",
	      fill: "#DFC586",
	      fillRule: "nonzero"
	    }),
	    _react2.default.createElement("path", {
	      d: "M15.427 44.808c0 .498.199.976.554 1.328l8.466 8.41c.476.473 1.291.138 1.291-.531v-18.845l-10.194-10.069h-.118v19.707",
	      fill: "#16788D",
	      fillRule: "nonzero"
	    }),
	    _react2.default.createElement("path", {
	      d: "M23.253 18.39c-.295-.293-.774-.293-1.069 0l-6.756 6.711 10.311 10.243 10.104 10.037v-14.485l-12.589-12.505",
	      fill: "#8ABB9C",
	      fillRule: "nonzero"
	    })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = PayPal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PayPal() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "112",
	      height: "28",
	      viewBox: "0 0 112 28",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "PayPal"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with Sketch."
	    ),
	    _react2.default.createElement(
	      "g",
	      { fill: "#0C1014", fillRule: "nonzero" },
	      _react2.default.createElement("path", {
	        d: "M41.739 6.096h-6.177c-.422 0-.782.307-.848.724l-2.498 15.84c-.023.149.02.3.118.415.098.114.241.18.392.18h2.949c.423 0 .783-.308.848-.725l.674-4.272c.065-.417.425-.725.847-.725h1.955c4.069 0 6.417-1.969 7.031-5.871.276-1.707.012-3.048-.788-3.988-.878-1.031-2.435-1.577-4.503-1.577zm.713 5.785c-.338 2.217-2.031 2.217-3.669 2.217h-.932l.654-4.139c.04-.25.255-.434.509-.434h.427c1.115 0 2.168 0 2.711.636.324.379.424.943.3 1.722zm17.752-.071h-2.958c-.253 0-.469.184-.509.434l-.131.827-.207-.3c-.64-.929-2.068-1.24-3.494-1.24-3.269 0-6.061 2.476-6.604 5.949-.283 1.732.119 3.389 1.102 4.544.901 1.062 2.191 1.505 3.726 1.505 2.634 0 4.094-1.694 4.094-1.694l-.132.822c-.024.149.019.3.116.415.098.115.241.181.391.181h2.665c.423 0 .783-.308.848-.725l1.599-10.124c.024-.148-.019-.3-.116-.414-.098-.114-.24-.18-.391-.18zm-4.123 5.757c-.285 1.69-1.627 2.824-3.337 2.824-.859 0-1.545-.275-1.986-.798-.437-.518-.603-1.256-.464-2.078.266-1.675 1.63-2.847 3.315-2.847.84 0 1.523.279 1.973.806.451.532.63 1.274.5 2.093zm19.877-5.757h-2.973c-.285 0-.551.141-.711.377l-4.1 6.039-1.738-5.803c-.11-.363-.444-.612-.824-.612h-2.921c-.166 0-.323.08-.42.215-.097.135-.123.309-.069.466l3.274 9.609-3.078 4.345c-.112.157-.126.363-.038.534.088.171.265.279.458.279h2.969c.281 0 .545-.137.705-.369l9.887-14.271c.109-.157.122-.362.033-.532-.089-.17-.264-.276-.456-.276z",
	        id: "Shape"
	      }),
	      _react2.default.createElement("path", {
	        d: "M85.799 6.096h-6.178c-.422 0-.781.307-.847.724l-2.498 15.84c-.024.148.019.3.117.414.098.114.24.18.391.18h3.17c.295 0 .547-.216.593-.508l.709-4.49c.065-.417.425-.725.847-.725h1.955c4.07 0 6.417-1.969 7.032-5.871.277-1.707.011-3.048-.789-3.988-.877-1.031-2.433-1.577-4.501-1.577zm.713 5.785c-.337 2.217-2.03 2.217-3.669 2.217h-.931l.655-4.139c.039-.25.254-.435.508-.434h.427c1.115 0 2.168 0 2.711.636.324.379.423.943.299 1.722zm17.751-.071h-2.956c-.253-.001-.469.184-.508.434l-.131.827-.208-.3c-.64-.929-2.067-1.24-3.493-1.24-3.269 0-6.06 2.476-6.603 5.949-.282 1.732.118 3.389 1.101 4.544.903 1.062 2.191 1.505 3.726 1.505 2.634 0 4.094-1.694 4.094-1.694l-.132.822c-.024.149.019.301.117.416.098.115.242.181.392.18h2.664c.422 0 .782-.308.847-.725l1.6-10.124c.023-.149-.02-.3-.118-.415-.098-.114-.241-.18-.392-.18zm-4.123 5.757c-.284 1.69-1.627 2.824-3.337 2.824-.857 0-1.545-.275-1.986-.798-.437-.518-.602-1.256-.464-2.078.268-1.675 1.63-2.847 3.315-2.847.84 0 1.523.279 1.973.806.453.532.631 1.274.5 2.093zm7.611-11.037l-2.535 16.13c-.024.148.019.3.117.414.098.114.24.18.391.18h2.549c.424 0 .783-.307.848-.725l2.5-15.839c.023-.149-.019-.3-.117-.414-.098-.114-.24-.18-.391-.181h-2.854c-.253.001-.468.185-.508.435z",
	        fillOpacity: ".6"
	      }),
	      _react2.default.createElement("path", {
	        d: "M20.731 7.422c-1.117 5.736-4.94 7.718-9.822 7.718h-2.486c-.597 0-1.1.434-1.193 1.022l-1.273 8.071-.36 2.288c-.029.184.024.371.144.512.121.141.297.223.483.223h4.409c.522 0 .966-.379 1.048-.894l.043-.224.83-5.268.053-.289c.081-.517.526-.896 1.048-.896h.659c4.271 0 7.615-1.734 8.592-6.753.408-2.096.197-3.847-.883-5.078-.342-.381-.751-.696-1.207-.93l-.087.497zm-2.169-1.204c-.725-.111-1.458-.165-2.191-.16h-6.641c-.522 0-.967.38-1.047.896l-1.413 8.947-.041.261c.091-.589.598-1.023 1.193-1.022h2.486c4.882 0 8.704-1.983 9.822-7.718l.087-.497c-.295-.155-.602-.284-.919-.387l-.25-.079c-.357-.103-.72-.184-1.087-.241z",
	        fillOpacity: ".6"
	      }),
	      _react2.default.createElement("path", { d: "M8.684 6.954c.08-.516.525-.897 1.047-.895h6.641c.787 0 1.521.051 2.191.16.454.071.901.178 1.338.319.33.109.636.238.919.387.332-2.12-.003-3.563-1.149-4.87-1.264-1.439-3.544-2.055-6.463-2.055h-8.472c-.596 0-1.105.434-1.197 1.023l-3.529 22.368c-.033.21.027.424.165.586.138.162.34.255.553.256h5.231l1.313-8.332 1.413-8.947z" })
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Cta;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _generalModule = __webpack_require__(250);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cta(_ref) {
	  var heading = _ref.heading,
	      ctaLink = _ref.ctaLink;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _generalModule2.default.cta },
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'l', position: 'bottom', type: 'margin' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'm', sizeM: '0', position: 'leftRight', type: 'padding' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 760 },
	            _react2.default.createElement(
	              _heading2.default,
	              { size: 'xxxl', weight: 'semibold', color: 'black' },
	              heading
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: ctaLink },
	        _react2.default.createElement(
	          _button2.default,
	          { shape: 'rounded', kind: 'flat', size: 'large' },
	          'Request a demo'
	        )
	      )
	    )
	  );
	}
	
	Cta.propTypes = {
	  heading: _customPropTypesCheck2.default,
	  ctaLink: _propTypes2.default.string
	};
	
	Cta.defaultProps = {
	  heading: 'Challenge the industry norm and become a CX centric design leader with Marvel Enterprise.',
	  ctaLink: '/enterprise/request-demo'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cta":"src-components-modules-Cta-CtaDemo-style----general-module---cta---35v6-"};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = IndustryHeader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _headerModule = __webpack_require__(253);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndustryHeader(_ref) {
	  var label = _ref.label,
	      imageAsset = _ref.imageAsset,
	      title = _ref.title,
	      paragraph = _ref.paragraph,
	      ctaLink = _ref.ctaLink;
	
	  var buttons = _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', sizeM: 'l', position: 'top', type: 'margin' },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.buttons },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.leftButton },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: ctaLink },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              size: 'large',
	              background: 'blue',
	              hover: 'blue',
	              shape: 'rounded',
	              minWidth: 180
	            },
	            'Request a demo'
	          )
	        )
	      )
	    )
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { className: _headerModule2.default.flex },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.firstCol },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', position: 'bottom', type: 'margin' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', size: 'm', weight: 'semibold' },
	            _react2.default.createElement(
	              'span',
	              { className: _headerModule2.default.label },
	              label
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: _headerModule2.default.heading },
	          title
	        ),
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 500 },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 's', position: 'top', type: 'margin' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'm', color: 'black' },
	              paragraph
	            )
	          )
	        ),
	        buttons
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.secondCol },
	      _react2.default.createElement(_Image2.default, _extends({}, imageAsset, { hasShadow: false, block: true }))
	    )
	  );
	}
	
	IndustryHeader.propTypes = {
	  imageAsset: _propTypes2.default.object,
	  label: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  paragraph: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  ctaLink: _propTypes2.default.string.isRequired
	};
	
	IndustryHeader.defaultProps = {
	  ctaLink: '/enterprise/request-demo'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-IndustryHeader-style----header-module---flex---2XcZw pageWrap pageWrap-l alignItems-center justifyContent-center breakPointM-display-flex breakPointM-textAlign-left","firstCol":"src-components-modules-IndustryHeader-style----header-module---firstCol---284-C breakPointM-marginBottom-0 breakPointM-marginRight-l breakPointM-textAlign-left textAlign-center marginBottom-l justifyContent-center marginRight-0","buttons":"src-components-modules-IndustryHeader-style----header-module---buttons---CnkfF breakPointM-flexDirection-row flexDirection-column justifyContent-start display-flex","label":"src-components-modules-IndustryHeader-style----header-module---label---715vJ","leftButton":"src-components-modules-IndustryHeader-style----header-module---leftButton---7UUP8 breakPointM-paddingRight-xxs breakPointM-paddingBottom-0 paddingBottom-xs","heading":"src-components-modules-IndustryHeader-style----header-module---heading---2IHjT fontWeight-5 marginBottom-m fontSize-xxxl breakPointS-fontSize-xxxxl","rightButton":"src-components-modules-IndustryHeader-style----header-module---rightButton---3L5Nk breakPointM-paddingLeft-xxs","secondCol":"src-components-modules-IndustryHeader-style----header-module---secondCol---2NiBb"};

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Logos;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _logoRow = __webpack_require__(53);
	
	var _logoRow2 = _interopRequireDefault(_logoRow);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _logosModule = __webpack_require__(254);
	
	var _logosModule2 = _interopRequireDefault(_logosModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logos(_ref) {
	  var logos = _ref.logos,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _paragraph2.default,
	        { size: 'm', color: 'black' },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _logosModule2.default.flex },
	      _react2.default.createElement(_logoRow2.default, {
	        logos: logos,
	        align: 'center',
	        color: 'black',
	        opacity: 100,
	        spacing: 'm'
	      })
	    )
	  );
	}
	
	Logos.propTypes = {
	  title: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  logos: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string, _propTypes2.default.array])
	};
	module.exports = exports['default'];

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-Logos-style----logos-module---flex---1UFmy alignItems-center justifyContent-center breakPointL-display-flex breakPointL-textAlign-left","cta":"src-components-modules-Logos-style----logos-module---cta---2mOF- paddingTop-l breakPointL-paddingLeft-m breakPointL-paddingTop-0"};

/***/ }),

/***/ 1204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = MonzoUpsell;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _MonzoRound = __webpack_require__(1147);
	
	var _MonzoRound2 = _interopRequireDefault(_MonzoRound);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ArrowLink = __webpack_require__(75);
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _monzo12x = __webpack_require__(2633);
	
	var _monzo12x2 = _interopRequireDefault(_monzo12x);
	
	var _monzo22x = __webpack_require__(2634);
	
	var _monzo22x2 = _interopRequireDefault(_monzo22x);
	
	var _monzoUpsellModule = __webpack_require__(1489);
	
	var _monzoUpsellModule2 = _interopRequireDefault(_monzoUpsellModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MonzoUpsell() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _monzoUpsellModule2.default.wrap },
	      _react2.default.createElement(
	        'div',
	        { className: _monzoUpsellModule2.default.top },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 485, display: 'inlineBlock' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h3', color: 'black', size: 'xxxxl', weight: 'semibold' },
	            'See how Marvel keeps Monzo shipping every 2 weeks.'
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'xl', type: 'margin', position: 'top' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/case-studies/monzo' },
	              _react2.default.createElement(
	                _ArrowLink2.default,
	                { size: 'l', weight: 'semibold', colour: 'blue' },
	                'Read Monzo\'s case study'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _monzoUpsellModule2.default.quote },
	      _react2.default.createElement(
	        'div',
	        { className: _monzoUpsellModule2.default.wrap },
	        _react2.default.createElement(
	          'div',
	          { className: _monzoUpsellModule2.default.primaryImage },
	          _react2.default.createElement(_Image2.default, {
	            alt: 'See how Marvel keeps Monzo shipping every 2 weeks.',
	            maxWidth: 390,
	            src: _monzo12x2.default,
	            hasShadow: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _monzoUpsellModule2.default.secondaryImage },
	          _react2.default.createElement(_Image2.default, {
	            alt: 'See how Marvel keeps Monzo shipping every 2 weeks.',
	            maxWidth: 410,
	            src: _monzo22x2.default,
	            hasShadow: false
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _monzoUpsellModule2.default.quoteWrapper },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'margin', position: 'bottom' },
	            _react2.default.createElement(_MonzoRound2.default, null)
	          ),
	          _react2.default.createElement(
	            'blockquote',
	            { className: _monzoUpsellModule2.default.blockquote },
	            '\u201CWe use Marvel a lot for user testing. Actually being able to create a scenario, prepare a flow for a person and have them walk through it step-by-step creates such valuable feedback.\u201D'
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'margin', position: 'top' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'silver' },
	              'Hugo C, Head of Design at Monzo'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1489:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-components-modules-MonzoUpsell-style----monzo-upsell-module---main---13rp5 textAlign-center paddingTopBottom-xl","wrap":"src-components-modules-MonzoUpsell-style----monzo-upsell-module---wrap---fjfjp pageWrap c-black textAlign-left position-relative pageWrap-l","top":"src-components-modules-MonzoUpsell-style----monzo-upsell-module---top---UApf5","quote":"src-components-modules-MonzoUpsell-style----monzo-upsell-module---quote---3J11Y bg-licorice paddingTopBottom-xl","quoteWrapper":"src-components-modules-MonzoUpsell-style----monzo-upsell-module---quoteWrapper---POwA- position-relative","blockquote":"src-components-modules-MonzoUpsell-style----monzo-upsell-module---blockquote---xhwMI c-white fontSize-xxl lineHeight-l fontWeight-4","primaryImage":"src-components-modules-MonzoUpsell-style----monzo-upsell-module---primaryImage---6FYEL position-absolute","secondaryImage":"src-components-modules-MonzoUpsell-style----monzo-upsell-module---secondaryImage---3G-pY position-absolute"};

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = SecurityCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _securityCardModule = __webpack_require__(740);
	
	var _securityCardModule2 = _interopRequireDefault(_securityCardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _securityCardModule2.default));
	
	var bgValues = ['teal', 'marvel', 'purple--l', 'orange--l', 'yellow--l', 'purple'];
	
	function SecurityCard(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      color = _ref.color,
	      raised = _ref.raised,
	      image = _ref.image;
	
	  var blockClasses = cx('flex', { raised: raised });
	  var circleClasses = cx('bg-' + color, 'circle');
	  return _react2.default.createElement(
	    'div',
	    { className: blockClasses },
	    _react2.default.createElement(
	      'div',
	      { className: circleClasses },
	      _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, image))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _securityCardModule2.default.content },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'left' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'xxs', type: 'margin', position: 'bottom' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h3', weight: 'bold', size: 'm', color: 'black' },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'silver' },
	          subtitle
	        )
	      )
	    )
	  );
	}
	
	SecurityCard.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  raised: _propTypes2.default.bool,
	  color: _propTypes2.default.oneOf(bgValues).isRequired,
	  subtitle: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Security;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _assets = __webpack_require__(62);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _ArrowLink = __webpack_require__(75);
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _SecurityCard = __webpack_require__(607);
	
	var _SecurityCard2 = _interopRequireDefault(_SecurityCard);
	
	var _securityModule = __webpack_require__(741);
	
	var _securityModule2 = _interopRequireDefault(_securityModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Security() {
	  return _react2.default.createElement(
	    'div',
	    { className: _securityModule2.default.main },
	    _react2.default.createElement(
	      'div',
	      { className: _securityModule2.default.wrap },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 620 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'black' },
	            'Your security and compliance needs covered'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 550 },
	          _react2.default.createElement(
	            _paragraph2.default,
	            { size: 'l' },
	            'Marvel Enterprise provides above industry standard security to protect your work and data. We are EU hosted, GDPR compliant and provide enhanced protection features such as Single Sign-On and access locks to secure projects.'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'm', type: 'margin', position: 'top' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/security' },
	            _react2.default.createElement(
	              _ArrowLink2.default,
	              { size: 'l', weight: 'semibold' },
	              'Read more about Security'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 3, alignItems: 'flex-end', size: 'l' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'Activity log exports',
	            subtitle: 'Keep an offline record of Marvel activity so you can refer back to it any time you need to',
	            color: 'yellow--l',
	            image: _assets2.default.logoLog,
	            raised: true
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'GDPR compliant',
	            subtitle: 'We\'re committed to meeting our legal obligation and protecting the data rights of our customers',
	            color: 'purple',
	            image: _assets2.default.logoEU
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'SAML-based SSO',
	            subtitle: 'Marvel Enterprise gives your business several layers of security to their accounts',
	            color: 'orange--l',
	            image: _assets2.default.logoSaml,
	            raised: true
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'IP Restriction & granular access',
	            subtitle: 'Restrict access by ensuring only users on a specific IP address can access your Marvel account',
	            color: 'marvel',
	            image: _assets2.default.logoGlobe
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: '99.98% Uptime SLA',
	            subtitle: 'Our distributed infrastructure means you get the best and most reliable experience possible',
	            color: 'purple--l',
	            image: _assets2.default.logoArrow,
	            raised: true
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'EU Hosted Infrastructure',
	            subtitle: 'Our data center maintains multiple certifications including SOC1, SOC 2, SOC 3, ISO27001',
	            color: 'teal',
	            image: _assets2.default.logoMap
	          })
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-SecuritySection-style----security-card-module---flex---3bupV display-flex borderRadius-l","raised":"src-components-modules-SecuritySection-style----security-card-module---raised---1jkDg bg-snow","circle":"src-components-modules-SecuritySection-style----security-card-module---circle---1iacp marginRight-m display-block overflow-hidden borderRadius-circle","content":"src-components-modules-SecuritySection-style----security-card-module---content---12LY- flex-1"};

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-components-modules-SecuritySection-style----security-module---main---y3eDE textAlign-center paddingTopBottom-xl","wrap":"src-components-modules-SecuritySection-style----security-module---wrap---1vr8p pageWrap c-black textAlign-center pageWrap-l"};

/***/ }),

/***/ 1234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _democratise2x = __webpack_require__(2630);
	
	var _democratise2x2 = _interopRequireDefault(_democratise2x);
	
	var _hero2x = __webpack_require__(2631);
	
	var _hero2x2 = _interopRequireDefault(_hero2x);
	
	var _ideate2x = __webpack_require__(2632);
	
	var _ideate2x2 = _interopRequireDefault(_ideate2x);
	
	var _ogPreview = __webpack_require__(511);
	
	var _ogPreview2 = _interopRequireDefault(_ogPreview);
	
	var _validate2x = __webpack_require__(2635);
	
	var _validate2x2 = _interopRequireDefault(_validate2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  hero: {
	    alt: 'Disrupt and deliver with innovative Design Thinking',
	    src: _hero2x2.default,
	    maxWidth: 647
	  },
	  ideate: {
	    alt: 'Ideate, create and ship user-centric solutions',
	    src: _ideate2x2.default,
	    maxWidth: 647
	  },
	  validate: {
	    alt: 'Validate fast and reduce your time to market',
	    src: _validate2x2.default,
	    maxWidth: 734
	  },
	  democratise: {
	    alt: 'Democratise design and drive digital transformation',
	    src: _democratise2x2.default,
	    maxWidth: 660
	  },
	  sharePreview: {
	    src: _ogPreview2.default,
	    maxWidth: 1200
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 1235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Monzo = __webpack_require__(94);
	
	var _Monzo2 = _interopRequireDefault(_Monzo);
	
	var _Stripe = __webpack_require__(117);
	
	var _Stripe2 = _interopRequireDefault(_Stripe);
	
	var _PayPal = __webpack_require__(1148);
	
	var _PayPal2 = _interopRequireDefault(_PayPal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logos = [{
	  id: 0,
	  logo: _Stripe2.default
	}, {
	  id: 1,
	  logo: _Monzo2.default
	}, {
	  id: 2,
	  logo: _PayPal2.default
	}];
	
	exports.default = logos;
	module.exports = exports['default'];

/***/ }),

/***/ 2630:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/democratise@2x-5eaf86a6f5540881918502bbef6e08b4.jpg";

/***/ }),

/***/ 2631:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero@2x-bdc6f8a4feed90724669efec93ca635c.jpg";

/***/ }),

/***/ 2632:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ideate@2x-fcb93c33bc9e2798b7af1400a7a95090.jpg";

/***/ }),

/***/ 2633:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/monzo-1@2x-b35e4ad99b97ba07787654ae934506e9.jpg";

/***/ }),

/***/ 2634:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/monzo-2@2x-634e5f0e678df79dcaf40cef1a5c7013.jpg";

/***/ }),

/***/ 2635:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/validate@2x-f3513da936bf8d809909221e042099a2.jpg";

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FinancialServices;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _assets = __webpack_require__(1234);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _logos = __webpack_require__(1235);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _SecuritySection = __webpack_require__(608);
	
	var _SecuritySection2 = _interopRequireDefault(_SecuritySection);
	
	var _ImageBlock = __webpack_require__(149);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _Logos = __webpack_require__(206);
	
	var _Logos2 = _interopRequireDefault(_Logos);
	
	var _IndustryHeader = __webpack_require__(204);
	
	var _IndustryHeader2 = _interopRequireDefault(_IndustryHeader);
	
	var _CtaDemo = __webpack_require__(199);
	
	var _CtaDemo2 = _interopRequireDefault(_CtaDemo);
	
	var _MonzoUpsell = __webpack_require__(1204);
	
	var _MonzoUpsell2 = _interopRequireDefault(_MonzoUpsell);
	
	var _hubspot = __webpack_require__(46);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var facebookMeta = [{
	  name: 'og:title',
	  content: 'Marvel for Finance - Create better customer experiences'
	}, {
	  name: 'og:site_name',
	  content: 'Marvel for Finance'
	}, {
	  name: 'og:type',
	  content: 'website'
	}, {
	  name: 'og:url',
	  content: 'https://marvelapp.com/financial-services'
	}, {
	  name: 'og:description',
	  content: "Explore how Marvel's collaborative design platform can help your financial business create a better customer experience and drive digital transformation."
	}, {
	  name: 'og:image',
	  content: 'https://marvelapp.com' + _assets2.default.sharePreview.src
	}, {
	  name: 'og:site_name',
	  content: 'Marvel for Finance'
	}];
	
	var twitterMeta = [{
	  name: 'twitter:site',
	  content: 'https://marvelapp.com/financial-services'
	}, {
	  name: 'twitter:creator',
	  content: '@marvelapp'
	}, {
	  name: 'twitter:title',
	  content: 'Marvel for Finance - Create better customer experiences'
	}, {
	  name: 'twitter:image',
	  content: 'https://marvelapp.com' + _assets2.default.sharePreview.src
	}];
	
	var meta = {
	  title: _metadata2.default['financial-services'].title,
	  meta: [{
	    name: 'description',
	    content: _metadata2.default['financial-services'].description
	  }].concat(twitterMeta, facebookMeta),
	  header: { isLight: false },
	  footer: true
	};
	
	function FinancialServices() {
	  var ctaLink = '/enterprise/request-demo?hformid=' + _hubspot.requestDemoFinanceId;
	
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(_IndustryHeader2.default, {
	      label: 'Marvel for Financial Services',
	      imageAsset: _assets2.default.hero,
	      title: 'Disrupt and deliver with innovative Design Thinking',
	      paragraph: 'Marvel makes it easy to introduce and implement new user-centric methodologies and workflows that transform your customer\'s digital experience. Design is at the centre of innovation and our tools can help you open up the design processes to your entire business, increase your time to market and connect you with your audience, fast.',
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_Logos2.default, {
	      title: _react2.default.createElement(
	        'span',
	        null,
	        'Join these leading financial companies who use',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { style: { fontWeight: 'bold' } },
	          'Marvel Enterprise'
	        ),
	        ' to scale design'
	      ),
	      logos: _logos2.default
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Ideate, create and ship user-centric solutions',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'Research has found that when human-centered design sits at the core of a growth strategy, it brings a 228% higher ROI. With built-in User Testing, Marvel enables you to reach your customers, wherever they are in the world, through sharing a single URL.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'Collate video, audio and analytical feedback for your prototypes in a single space. No hardware or lab space required!'
	      ),
	      headingMaxWidth: 390,
	      paragraphMaxWidth: 480,
	      imageAsset: _assets2.default.ideate,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Validate fast and reduce your time to market',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'Consolidate your tools with Marvel and experience a collaborative space to create and share design work, fast. Our customers see feedback loops closed to minutes using features like commenting, annotating and visibility dashboards.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'Our platform is built to scale with integrations like Sketch, Microsoft Teams and JIRA which boost productivity and automate your design process.'
	      ),
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.validate,
	      isRightAligned: true,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Democratise design and drive digital transformation',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'From designers to researchers and analysts, Marvel consolidates and simplifies dozens of professional, creative workflow tools - enabling every department to wireframe, design and prototype.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'We strive to lower the entry barrier for design and creative tooling. That\'s why it takes less than 30 minutes to onboard and complete your first project with Marvel. With no learning curve, our platform empowers every team to drive a design-led culture.'
	      ),
	      headingMaxWidth: 458,
	      paragraphMaxWidth: 458,
	      imageAsset: _assets2.default.democratise,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_SecuritySection2.default, null),
	    _react2.default.createElement(_MonzoUpsell2.default, null),
	    _react2.default.createElement(_CtaDemo2.default, {
	      heading: 'Challenge the industry norm and become a CX centric design leader with Marvel Enterprise.',
	      ctaLink: ctaLink
	    })
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-financial-services-index-js-c6868c77eb82261f43c2.js